import _ from 'lodash';

export function getName(stepState: Record<string, any>): string {
  return _.get(stepState, 'step-1-state.name', '');
}
